export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-label-960-92bc740df07edf803805f97e38e70602.png";